import { useSearchParams, useLocation } from "react-router-dom";
import AuthForm from "../../components/forms/AuthForm";
import SmallAlert from "../../components/ui/alerts/SmallAlert";
import TwoColumnAuth from "../../components/layouts/TwoColumnAuth";

function SignIn({ isAdmin = false }) {
  const [searchParams] = useSearchParams();
  const redirectPath =
    searchParams.get("path") || (isAdmin ? "/custom-admin/dashboard" : "/");
  // Presence-only marker for a mobile-wrapper transaction (Custom Tab /
  // SFSafariViewController); its name is an internal implementation detail
  // coordinated with plaintr-mobile, not a public contract.
  const mobileTransaction = searchParams.get("mobile") !== null;

  const { state } = useLocation();
  // default to empty object so we never read undefined
  const { type: alertType = null, message: alertMessage = null } = state ?? {};

  return (
    <main className="auth-page">
      <TwoColumnAuth>
        {/* show the flash alert for both success & error */}
        {alertMessage && (
          <SmallAlert
            alert="True"
            title={alertType === "success" ? "Success" : "Error"}
            type={alertType}
            message={alertMessage}
            dynamicSize
            style={{ marginBottom: 24 }}
          />
        )}

        <AuthForm
          redirectPath={redirectPath}
          isAdmin={isAdmin}
          mobileTransaction={mobileTransaction}
        />
      </TwoColumnAuth>
    </main>
  );
}

export default SignIn;
